import { render, staticRenderFns } from "./GroupsItem.vue?vue&type=template&id=13bd8eeb&"
import script from "./GroupsItem.vue?vue&type=script&lang=js&"
export * from "./GroupsItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupsItem.vue?vue&type=style&index=0&id=13bd8eeb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports